import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType, ApplicationSuggestionSelectedEventType } from '../constants';

export class SuggestionSelectedApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.SuggestionSelected;

  constructor(
    private suggestionType: ApplicationSuggestionSelectedEventType,
    private inputText?: string,
    private suggestionsCount?: number,
    private promotionsCount?: number,
    private selectedSuggestionText?: string,
    private selectedSuggestionIndex?: number,
    private selectedPromotionMid?: string,
    private selectedPromotionName?: string,
    private selectedCategory?: string
  ) {
  }

  getPayload(): any {
    return {
      type: this.suggestionType,
      inputText: this.inputText,
      suggestionsCount: this.suggestionsCount,
      promotionsCount: this.promotionsCount,
      selectedSuggestionText: this.selectedSuggestionText,
      selectedSuggestionIndex: this.selectedSuggestionIndex,
      selectedPromotionMid: this.selectedPromotionMid,
      selectedPromotionName: this.selectedPromotionName,
      selectedCategory: this.selectedCategory
    };
  }
}
